// extracted by mini-css-extract-plugin
export var arrowContainer = "lpCompetitorSection-module--arrowContainer--de46b";
export var cardContainer = "lpCompetitorSection-module--cardContainer--f3a04";
export var col = "lpCompetitorSection-module--col--2c503";
export var col1 = "lpCompetitorSection-module--col1--3cba9";
export var col2 = "lpCompetitorSection-module--col2--69041";
export var col3 = "lpCompetitorSection-module--col3--9fd7e";
export var container = "lpCompetitorSection-module--container--c8b44";
export var label = "lpCompetitorSection-module--label--e8658";
export var logo = "lpCompetitorSection-module--logo--cc956";
export var row = "lpCompetitorSection-module--row--d8fd7";
export var secondaryLogo = "lpCompetitorSection-module--secondaryLogo--48d16";
export var secondaryLogoImage = "lpCompetitorSection-module--secondaryLogoImage--30478";
export var textContainer = "lpCompetitorSection-module--textContainer--4dd28";